import {apiCall} from "../../common/apiActionHandler";
import axios from "axios";

export const logError = (data) => async (dispatch, getState) => {
    const config = {
        method: 'post',
        url: `/api/frontend_errors/log`,
        data
    }

    apiCall("Logging frontend error", config, async config => {
        await axios.request(config);
    }, dispatch, getState, false);
};